/* Generic hero slideshow — shared by cn-hero / wl-hero.
   Data-attribute driven so each section keeps its own BEM classes.
     root   : [data-hero-slider] (+ data-autoplay, data-speed)
     slide  : [data-hero-slide]
     dot    : [data-hero-dot]
     arrows : [data-hero-prev] / [data-hero-next]
   Active state = `is-active` class on the current slide + dot.
   Cross-fade, autoplay, arrows, dots, swipe, pause-on-hover,
   pause when tab hidden, respects prefers-reduced-motion. */
(function () {
  function init(root) {
    if (root.dataset.heroSliderReady === '1') return;
    root.dataset.heroSliderReady = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    if (slides.length <= 1) {
      root.classList.add('is-single');
      return;
    }

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.dataset.autoplay === 'true' && !reduce;
    var speed = (parseFloat(root.dataset.speed) || 5) * 1000;
    var i = 0;
    var timer = null;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        var a = idx === i;
        s.classList.toggle('is-active', a);
        s.setAttribute('aria-hidden', a ? 'false' : 'true');
      });
      dots.forEach(function (d, idx) {
        var a = idx === i;
        d.classList.toggle('is-active', a);
        d.setAttribute('aria-selected', a ? 'true' : 'false');
      });
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (autoplay) timer = setInterval(function () { show(i + 1); }, speed);
    }
    function go(n) { show(n); start(); }

    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () { go(idx); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    var x0 = null;
    root.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    root.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
    });
    root.addEventListener('pointercancel', function () { x0 = null; });

    show(0);
    start();
  }

  // Publish the header (announcement bar + bar) height as --header-h so a
  // full-screen hero can be sized as calc(100svh - var(--header-h)).
  function measureHeader() {
    var header = document.querySelector('.dh');
    var h = header ? header.offsetHeight : 0;
    document.documentElement.style.setProperty('--header-h', h + 'px');
  }

  function boot(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.slice
      .call(root.querySelectorAll('[data-hero-slider]'))
      .forEach(init);
    measureHeader();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });

  window.addEventListener('resize', measureHeader);
  window.addEventListener('load', measureHeader);
  // Re-measure if the announcement bar is dismissed (header shrinks).
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.dh-announce__close')) {
      setTimeout(measureHeader, 50);
    }
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) boot(e.target);
  });
})();
